// extracted by mini-css-extract-plugin
module.exports = {"container":"licenses_container__1vF0O","zoomcontainer":"licenses_zoomcontainer__3NGR9"};